export default __webpack_public_path__ + "static/media/help-rav-inv-22.927f5428.png";